import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";

import { Spinner, Table } from "react-bootstrap";

export const CattleDetailViewTable = ({ LeadsDataHalf }) => {
  return (
    <>
      <Table className="table mb-2" hover>
        <tbody>
          {[
            {
              label: "Name",
              value: `${LeadsDataHalf?.first_name ??
                ""} ${LeadsDataHalf?.last_name ?? ""}`,
            },
            { label: "Gender", value: LeadsDataHalf?.gender },
            { label: "DOB", value: LeadsDataHalf?.DOB },
            { label: "Age", value: LeadsDataHalf?.age },
            { label: "Mobile", value: LeadsDataHalf?.phone_number },
            {
              label: "Primary Occupation",
              value: LeadsDataHalf?.primary_occupation,
            },
            { label: "State", value: LeadsDataHalf?.state_name },
            { label: "District", value: LeadsDataHalf?.district_name },
            { label: "Block", value: LeadsDataHalf?.block_name },
            { label: "Pincode", value: LeadsDataHalf?.pincode },
            { label: "Address", value: LeadsDataHalf?.address },
            { label: "Status", value: LeadsDataHalf?.current_status },
          ]
            .reduce((rows, item, i, arr) => {
              if (i % 2 === 0)
                rows.push([item, arr[i + 1] || { label: "", value: "" }]);
              return rows;
            }, [])
            .map((row, rIdx) => (
              <tr key={rIdx}>
                {row.map((cell, cIdx) => (
                  <React.Fragment key={cIdx}>
                    <th
                      scope="row"
                      className="align-middle"
                      style={{ width: "20%" }}
                    >
                      {cell.label && cell.label !== "Address"
                        ? `${cell.label}:`
                        : cell.label}
                    </th>
                    <td className="align-middle" style={{ width: "30%" }}>
                      {cell.label === "Status" ? (
                        <span
                          style={{
                            color: "#27ae60",
                            fontSize: "12px",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {/* {cell.value ?? "-"} */}
                          {cell.value?.toLowerCase().replace(/_/g, " ")}
                        </span>
                      ) : (
                        cell.value ?? "-"
                      )}
                    </td>
                  </React.Fragment>
                ))}
              </tr>
            ))}
        </tbody>
      </Table>
    </>
  );
};
